import type { ExpressPaymentType } from '@stripe/stripe-js';
import { PapiOrderV3 } from '@wix/da-papi-types';
import { Url } from '@wix/da-url';
import { PaymentMethod } from '../types';

export function getApplePayRequestOptionsV3(order: PapiOrderV3) {
  if (order.isRecurring) {
    return {
      recurringPaymentRequest: {
        paymentDescription: order.product.productName,
        managementURL: Url.account(),
        regularBilling: {
          label: order.product.productName,
          amount: order.product.price.cents,
          recurringPaymentStartDate: new Date(),
          recurringPaymentIntervalCount: 1,
          recurringPaymentIntervalUnit:
            (order.product.corePackage?.interval as 'month' | 'year') ??
            'month',
        },
      },
    };
  }
  return undefined;
}

export function expressPaymentTypeToPaymentMethod(
  paymentType: ExpressPaymentType
) {
  if (paymentType === 'apple_pay') {
    return PaymentMethod.APPLE_PAY;
  }
  return PaymentMethod.GOOGLE_PAY;
}
